import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const HealthScoringPage = lazy(() => import('./pages/HealthScoringPage'));
const EngagementTrackingPage = lazy(() => import('./pages/EngagementTrackingPage'));
const PlaybooksPage = lazy(() => import('./pages/PlaybooksPage'));
const TaskAutomationPage = lazy(() => import('./pages/TaskAutomationPage'));
const EbrPage = lazy(() => import('./pages/EbrPage'));

export const SuccessRoutes: RouteObject = {
  path: 'success',
  element: <ModuleGuard moduleId="marketing.success" />,
  handle: { crumb: 'Customer Success' },
  children: [
    { index: true, element: <Navigate to="health-scoring" replace /> },
    { path: 'health-scoring', element: <HealthScoringPage />, handle: { crumb: 'Health Scoring' } },
    { path: 'engagement-tracking', element: <EngagementTrackingPage />, handle: { crumb: 'Engagement Tracking' } },
    { path: 'playbooks', element: <PlaybooksPage />, handle: { crumb: 'Playbooks' } },
    { path: 'task-automation', element: <TaskAutomationPage />, handle: { crumb: 'Task Automation' } },
    { path: 'ebr', element: <EbrPage />, handle: { crumb: 'EBR' } },
  ],
};
